import React from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import './JobVacancy.css';

const JobVacancy = () => {
  const jobs = [
    {
      title: 'Registered Nurse',
      location: 'Guntur',
      type: 'Full Time',
      description: 'Experienced RN for home nursing services. Must have valid nursing license and 2+ years experience.'
    },
    {
      title: 'Physiotherapist',
      location: 'Guntur',
      type: 'Full Time',
      description: 'Licensed physiotherapist for home-based rehabilitation services. Experience in geriatric care preferred.'
    },
    {
      title: 'Caregiver',
      location: 'Guntur',
      type: 'Full Time / Part Time',
      description: 'Compassionate caregivers for elderly and palliative care. Training will be provided.'
    },
    {
      title: 'Medical Assistant',
      location: 'Guntur',
      type: 'Full Time',
      description: 'Support medical staff with patient care, documentation, and coordination of home visits.'
    }
  ];

  return (
    <div className="job-vacancy-page">
      <section className="page-hero">
        <Container>
          <h1>Career Opportunities</h1>
          <p>Join Our Team of Healthcare Professionals</p>
        </Container>
      </section>

      <section className="jobs-section">
        <Container>
          <h2 className="text-center mb-5">Current Openings</h2>
          <Row className="g-4">
            {jobs.map((job, index) => (
              <Col key={index} lg={6}>
                <Card className="job-card h-100">
                  <Card.Body>
                    <h3>{job.title}</h3>
                    <div className="job-meta">
                      <span><FaMapMarkerAlt /> {job.location}</span>
                      <span><FaClock /> {job.type}</span>
                    </div>
                    <p>{job.description}</p>
                    <Button variant="primary">Apply Now</Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="application-section">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto">
              <Card className="application-card">
                <Card.Body>
                  <h2 className="text-center mb-4">Quick Application Form</h2>
                  <Form>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Full Name</Form.Label>
                          <Form.Control type="text" placeholder="Enter your name" />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" placeholder="Enter your email" />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control type="tel" placeholder="Enter phone number" />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Position Applied For</Form.Label>
                          <Form.Select>
                            <option>Select Position</option>
                            <option>Registered Nurse</option>
                            <option>Physiotherapist</option>
                            <option>Caregiver</option>
                            <option>Medical Assistant</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-3">
                      <Form.Label>Experience (Years)</Form.Label>
                      <Form.Control type="number" placeholder="Years of experience" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Cover Letter</Form.Label>
                      <Form.Control as="textarea" rows={4} placeholder="Tell us about yourself" />
                    </Form.Group>
                    <Button variant="info" size="lg" className="w-100">
                      Submit Application
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default JobVacancy;
